import template from './customer.create.html';
import controller from './customer.create.controller';
import './customer.create.controller';

let customercreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default customercreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/create/customer.create.component.js